import { Stack, Typography, useTheme } from "@mui/material";
import CustomButton from '../../../components/form/custom-button';
import { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const BlogCallToAction = ({
    details
}) => {
    const theme = useTheme();
    const {t} = useTranslation();

    const navigate = useNavigate();

    const onClick = useCallback(() => {
        navigate('/contact');
    }, [details]);

    return (
        <>
            <Stack
                direction='column'
                justifyContent='center'
                alignItems='center'
                width='100%'
                pt={{xs: 3, md: 6}}
                spacing={{xs: 2, md: 4}}
            >
                <Typography
                    fontWeight={600}
                    fontSize={{xs: 12, md: 16, lg: 24}}
                    textAlign='center'
                    color={theme.palette.text.secondary}
                    lineHeight={1.5}
                >
                    {details.description}
                </Typography>

                <CustomButton 
                    label={t('blogs.contact')}
                    onClick={onClick}
                    needAnimation
                />
            </Stack>
        </>
    );
}

export default BlogCallToAction;